import React from 'react';

const Loading = () => {
  return (
    <div class="loading-wrapper">
      <div className='loading'>
      </div>
    </div>
  );
};

export default Loading;
